import { FunctionComponent } from 'react';
import { ShoppingCart, StopCircle, AlarmOn } from '../../icons';
import { Button, Chip } from '../../../tailwindcomponents';
import { LinePackageOverviewObj } from '../../../types/line';
import { palette } from '../../../theme/palette';

type WorkPackageActionButtonsProps = {
  reports: Array<LinePackageOverviewObj>;
  onShowOutstandingMaterials: () => void;
  onShowPackagesOnHold: () => void;
  onShowDateConflicts: () => void;
  onShowPriorityItems: () => void;
};

const WorkPackageActionButtons: FunctionComponent<WorkPackageActionButtonsProps> = ({
  reports,
  onShowOutstandingMaterials,
  onShowPackagesOnHold,
  onShowDateConflicts,
  onShowPriorityItems,
}) => {
  const packagesOnHoldCount = reports.filter(s => s.is_wo_on_hold).length;
  const dateConflictCount = reports.filter(s => s.start_date_bigger_than_due_date).length;
  const priorityItemsCount = reports.filter(s =>  s.task_priority !== null && s.task_priority !== undefined && s.task_priority !== "" ).length;

  return (
    <div className="flex flex-row flex-wrap items-center gap-2 w-full mb-2">
      <div className="flex flex-wrap gap-2">
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onShowOutstandingMaterials}
          startIcon={<ShoppingCart color="error" />}
        >
          Unavailable Material
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onShowPackagesOnHold}
          startIcon={<StopCircle />}
        >
          {`Packages on hold (${packagesOnHoldCount})`}
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onShowDateConflicts}
          startIcon={<AlarmOn />}
        >
          {`Start date later than due date (${dateConflictCount})`}
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onShowPriorityItems}
        >
          <div className="w-[18px] h-[18px] bg-red-600 text-white font-bold text-[10px] flex items-center justify-center rounded-full text-center shrink-0 mr-[10px]">
            P
          </div>
          {`Priority items (${priorityItemsCount})`}
        </Button>
      </div>

      <div>
        <div className="flex flex-wrap gap-2 items-center">
          <div>
            <Chip
              style={{ backgroundColor: palette.shift.day }}
              label="Dayshift"
              variant="filled"
            />
          </div>
          <div>
            <Chip
              style={{ backgroundColor: palette.shift.night }}
              label="Nightshift"
              variant="filled"
            />
          </div>
          <div>
            <Chip
              style={{ backgroundColor: palette.error }}
              label="Start and due date conflict"
              variant="filled"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkPackageActionButtons;
